export default "__VITE_ASSET__993e56d7__"